import React from "react";
import '../styles/tssBenefits.scss';
import { MdOutlineRocketLaunch } from "react-icons/md";
import image from "../images/tss-benifits.png";

export default function TSSBenifits() {

    let keyBenifits = [
        {
            "icon": <MdOutlineRocketLaunch />,
            "text": "",
            "desc": "Hello! I'm Yashal Ali Farooqui, a passionate and innovative Frontend Developer from Karachi, Pakistan. Currently, I'm pursuing a Bachelor of Engineering in Computer Systems at NED University of Engineering and Technology, where I'm honing my skills and broadening my knowledge in programming, data structures, algorithms, and software engineering.",
            "desc2":"With a strong foundation in technologies like Next.js, React, and CSS, I've developed and optimized user interfaces for seamless and engaging user experiences.Feel free to explore my work and connect with me",
        },  
        
    ]

    return (
        <section id="tss-benefits" className="overflow-hidden">
            <div className="container">
                <div className="d-flex flex-column gap-2 mb-lg-3 mb-md-2 mb-5">
                    <h1 className="h2 fw-bold text-center text-uppercase text-gradient m-0">About Me</h1>
                </div>
                <div className="row align-items-center m-0 row-gap-2">
                    <div className="col-lg-6 col-md-7 px-md-2 p-0" data-aos="fade-right">
                        <ul className="d-flex flex-column gap-1 m-0">
                            {keyBenifits.map((keyBenefit, index) => {
                                return (
                                    <div key={index}><h1>{keyBenefit.text}</h1>
                                    <p>{keyBenefit.desc}</p>
                                    <br/>
                                    <p>{keyBenefit.desc2}</p></div>
                                )
                            })}
                        </ul>
                    </div>
                    <div className="col-lg-6 col-md-5 col-sm-8 d-block ms-sm-auto" data-aos="fade-left">
                        <img src={image} alt="" className="w-100" />
                    </div>
                </div>
            </div>
        </section>
    );
}